namespace UError {
  export class Unsupported extends Error {
    name = "UnsupportedError";
    constructor(message = "") {
      super(message);
    }
  }
  export namespace Unsupported {
    export const fn = () => {
      throw new Unsupported();
    };
  }
  export class Unreachable extends Error {
    name = "UnreachableError";

    constructor(message = "Unexpectedly encountered an unreachable case") {
      super(message);
    }
  }
}

export default UError;
